import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { applyBranding } from "../lib/branding";
import { useAuth } from "./AuthContext";

const BrandingCtx = createContext(null);

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState(null);

  const load = useCallback(() => {
    if (!localStorage.getItem("omnia_token")) {
      setBranding({});
      return;
    }
    api.get("/tenants/branding")
      .then((r) => setBranding(r.data || {}))
      .catch(() => setBranding({}));
  }, []);

  // Reload branding whenever the authenticated user (and thus their tenant) changes.
  useEffect(() => { load(); }, [load, user?.id, user?.tenant_id]);
  useEffect(() => { if (branding !== null) applyBranding(branding); }, [branding]);

  return (
    <BrandingCtx.Provider value={{ branding: branding || {}, reload: load }}>
      {children}
    </BrandingCtx.Provider>
  );
}

export const useBranding = () => useContext(BrandingCtx) || { branding: {}, reload: () => {} };
